export default "__VITE_ASSET__CsteboD9__"